import React from 'react';
import moment from 'moment';
import { _DateContainer, _Icon } from "./style";
import { DOCUMENT_TYPE_ICON as DocumentType, PAYMENT_TYPE_ICON as PaymentType, QUESTION_ANSWER_ICON as QuestionAnswer, RECEIPT_ICON as ReceiptType, ROCKET_SHIP_ICON as RocketShip } from "../../../../util/cdnAssets";
export default function TimelineRowDate(_ref) {
  var date = _ref.date,
    type = _ref.type;
  var icon;
  switch (type) {
    case 'base':
      icon = RocketShip;
      break;
    case 'documentRequirement':
      icon = DocumentType;
      break;
    case 'questionRequirement':
      icon = QuestionAnswer;
      break;
    case 'disclaimerRequirement':
      icon = DocumentType;
      break;
    case 'receiptRequirement':
      icon = ReceiptType;
      break;
    case 'paymentRequirement':
      icon = PaymentType;
      break;
  }
  if (type === 'base') {
    return /*#__PURE__*/React.createElement(_DateContainer, null, icon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      src: icon,
      alt: "icon"
    })), date && moment(date).format('DD MMM, YYYY'));
  }
  return /*#__PURE__*/React.createElement(_DateContainer, null, icon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Icon, {
    src: icon,
    alt: "icon"
  })), date && moment(date).format('DD MMM, YYYY'));
}